import { PaypalHelper } from '../../../helper/paypal_helper';
import { IActiveSubscription } from '../../../types/model';

export const subscriptionAccountHolderSelector = (): string => {
    const subscriptions = PaypalHelper.getSubscriptions() as Array<IActiveSubscription>;
    return subscriptions.map(subscription => subscription.authorId).join(', ');
};
